import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FadeAnimationComponent } from './fade-animation.component';

@NgModule({
  declarations: [ FadeAnimationComponent ],
  imports: [ CommonModule ],
  exports: [ FadeAnimationComponent ],
})
export class ZefFadeAnimationModule { }
